/* ufp-lp-cook.js: /pages/cook lander (Scaled Marketing).
   Vanilla, deferred, runs once (every cook section prints the tag), binds each element once, re-binds on
   shopify:section:load. Works with ufp-lp.js (UTM pass-through, offer swap, anchors, reveal, swipe rows, sticky bar);
   the page is complete without either script. Every storage call is wrapped in try/catch.
   - size picker: ?size= then sessionStorage then the server default; emits ufp:primary-cta for the close band + sticky bar
   - close band follows the picked size
   - "How it works" story: the row of times is the progress indicator and a tap on a time slides to its card
   - fit finder chips (?fit=), the add-on row's arrows and counter (it counts only the cards a chip leaves showing),
     add-on Adding / Added / error states, own /cart/add.js fallback, cart tag
   No touch listeners move anything: the rows scroll natively, so vertical scrolling is never taken over. */
(function () {
  'use strict';
  if (window.ufpCook && window.ufpCook.v) return;
  var C = window.ufpCook = { v: 2 };
  var doc = document;
  var SIZE_KEY = 'ufp-cook-size';
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function $$(root, sel) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function once(el, name) { var k = 'data-ufp-cb-' + name; if (el.hasAttribute(k)) return false; el.setAttribute(k, ''); return true; }
  function ss(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return null; } return null; }
  function param(k) { try { return new URLSearchParams(location.search).get(k); } catch (e) { return null; } }
  function push(o) { try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(o); } catch (e) {} }
  function withParams(h) { var U = window.ufpLp; return U && U.withParams ? U.withParams(h) : h; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function emit(name, detail) {
    var U = window.ufpLp;
    if (U && U.emit) { U.emit(name, detail); return; }
    C.last = C.last || {}; C.last[name] = detail;
    try { doc.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }

  /* ------------------------------------------------------------ offer: hero off wins (fail-closed twin swap)
     The hero is off when it says so, or when its data-ufp-offer-end date has passed in Australia/Sydney (a cached
     page after the end date). Then every offer element hides (including the close band terms line),
     the plain twins come back, /discount/ buy links go straight to the product page, and if the open FAQ answer was
     the offer one, the first visible answer opens instead. */
  function sydneyToday() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function plainHref(h) {
    try {
      var u = new URL(h, location.href);
      if (u.pathname.indexOf('/discount/') !== 0) return h;
      var r = u.searchParams.get('redirect');
      if (!r || r.charAt(0) !== '/') return h;
      u.searchParams.delete('redirect');
      var q = u.searchParams.toString();
      return r + (q ? (r.indexOf('?') < 0 ? '?' : '&') + q : '');
    } catch (e) { return h; }
  }
  function offerTwins() {
    var hero = doc.querySelector('[data-ufp-hero][data-ufp-offer-state]');
    if (!hero) return;
    var off = hero.getAttribute('data-ufp-offer-state') !== 'on';
    var end = hero.getAttribute('data-ufp-offer-end');
    if (!off && end && sydneyToday() > end) {
      off = true;
      hero.setAttribute('data-ufp-offer-state', 'off');
      hero.removeAttribute('data-ufp-offer-live');
    }
    if (!off) return;
    var openBefore = $$(doc, '.ufp-lp .ufp-lp-faq__item[open]');
    $$(doc, '.ufp-lp [data-ufp-offer-only], .ufp-lp [data-ufp-offer], .ufp-lp[data-ufp-offer]').forEach(function (el) { el.hidden = true; });
    $$(doc, '.ufp-lp [data-ufp-offer-plain]').forEach(function (el) { el.hidden = false; });
    $$(doc, '.ufp-lp a[href*="/discount/"]').forEach(function (a) { var h = a.getAttribute('href'), n = plainHref(h); if (n !== h) a.setAttribute('href', n); });
    $$(doc, '.ufp-lp .ufp-lp-faq').forEach(function (faq) {
      var items = $$(faq, '.ufp-lp-faq__item');
      var hadOpen = openBefore.some(function (d) { return faq.contains(d) && d.hidden; });
      var openVisible = items.some(function (d) { return d.open && !d.hidden; });
      if (!hadOpen || openVisible) return;
      var first = items.filter(function (d) { return !d.hidden; })[0];
      if (first) first.open = true;
    });
  }

  /* ------------------------------------------------------------ hero size picker
     The detail feeds the close band (label, sublabel, href) and the sticky bar: "title" is the bar's first line
     (the product's short name) and "price" its second (the picked size and its price). */
  function detailFor(fs, r) {
    var a = fs.querySelector('.ufp-lp-cook-cta[data-i="' + r.getAttribute('data-i') + '"]');
    var href = a ? a.getAttribute('href') : '';
    var size = r.getAttribute('data-size');
    var amount = r.getAttribute('data-price');
    var call = r.hasAttribute('data-call');
    return {
      size: size,
      label: r.getAttribute('data-label'),
      sublabel: r.getAttribute('data-sublabel') || '',
      href: withParams(href),
      sticky_label: r.getAttribute('data-sticky'),
      cta_id: r.value,
      title: r.getAttribute('data-bar') || '',
      amount: amount,
      price: call ? size : size + ' · ' + amount,
      call: call,
      handle: a ? (a.getAttribute('data-ufp-product') || '') : ''
    };
  }
  function bindPick(root) {
    $$(root, '[data-ufp-cook-pick]').forEach(function (fs) {
      if (!once(fs, 'pick')) return;
      var radios = $$(fs, 'input[data-ufp-cook-size]');
      if (!radios.length) return;
      var host = fs.closest('.ufp-lp') || fs;
      var want = param('size') || ss(SIZE_KEY);
      if (want) radios.forEach(function (r) { if (r.value === want) r.checked = true; });
      function publish(r) {
        host.setAttribute('data-ufp-selected', r.value);
        emit('ufp:primary-cta', detailFor(fs, r));
      }
      fs.addEventListener('change', function (e) {
        var r = e.target;
        if (!r || !r.hasAttribute || !r.hasAttribute('data-ufp-cook-size')) return;
        ss(SIZE_KEY, r.value);
        publish(r);
        push({ event: 'ufp_size_select', ufp_size: r.value, ufp_lander: 'cook' });
      });
      var cur = radios.filter(function (r) { return r.checked; })[0] || radios[0];
      cur.checked = true;
      publish(cur);
    });
  }

  /* ------------------------------------------------------------ close band follows the picked size */
  function follow(d) {
    if (!d) return;
    $$(doc, '[data-ufp-follow-primary]').forEach(function (a) {
      if (d.href) a.setAttribute('href', d.href);
      var l1 = a.querySelector('[data-l1]');
      var l2 = a.querySelector('[data-l2]');
      var arrow = a.querySelector('[data-arrow]');
      if (l1 && d.label) l1.textContent = d.label;
      if (l2) { l2.textContent = d.sublabel || ''; l2.hidden = !d.sublabel; }
      if (arrow) arrow.hidden = !!d.call;
      if (d.cta_id) a.setAttribute('data-ufp-cta', (d.call ? 'close_call_' : 'close_buy_') + d.cta_id);
      if (d.handle && !d.call) a.setAttribute('data-ufp-product', d.handle); else a.removeAttribute('data-ufp-product');
    });
    // the shared sticky bar follows name, price and href itself; the analytics attributes follow here (sticky_<size>)
    $$(doc, '[data-ufp-sticky-link]').forEach(function (a) {
      if (!a.closest('[data-ufp-lander="cook"]')) return;
      if (d.cta_id) a.setAttribute('data-ufp-cta', (d.call ? 'sticky_call_' : 'sticky_') + d.cta_id);
      if (d.handle && !d.call) a.setAttribute('data-ufp-product', d.handle); else a.removeAttribute('data-ufp-product');
    });
  }

  /* ------------------------------------------------------------ pill labels: no scroll jump on tap (Chromium)
     A tap on a label focuses its visually hidden radio, which sits above the pill (top of the card or form), and
     Chromium scrolls that radio into view. Check the radio ourselves and focus it without scrolling. No
     stopPropagation, so the shared data-ufp-cta click push still fires. Keyboard use (arrows, space) is untouched. */
  function onLabelClick(e) {
    var l = e.target && e.target.closest ? e.target.closest('.ufp-lp-cook label[for]') : null;
    if (!l) return;
    var r = doc.getElementById(l.htmlFor);
    if (!r || r.type !== 'radio' || r.disabled) return;
    e.preventDefault();
    if (!r.checked) {
      r.checked = true;
      try { r.dispatchEvent(new Event('change', { bubbles: true })); } catch (x) {
        var ev = doc.createEvent('HTMLEvents'); ev.initEvent('change', true, false); r.dispatchEvent(ev);
      }
    }
    try { r.focus({ preventScroll: true }); } catch (x) {}
  }

  /* ------------------------------------------------------------ compare table buy links: remember the
     size, like the pills do, so Back from the product page restores it in the hero, close band and sticky bar */
  function bindCompare(root) {
    $$(root, '[data-ufp-compare-size]').forEach(function (a) {
      if (!once(a, 'cmp')) return;
      a.addEventListener('click', function () { ss(SIZE_KEY, a.getAttribute('data-ufp-compare-size')); });
    });
  }

  /* ------------------------------------------------------------ links back up to the size picker ("Pick your
     size"): once the shared script has scrolled there, focus the checked size */
  function bindFocusSize(root) {
    $$(root, '.ufp-lp a[href="#ufp-buy"], [data-ufp-focus-size]').forEach(function (a) {
      if (!once(a, 'focus')) return;
      a.addEventListener('click', function () {
        var r = doc.querySelector('[data-ufp-cook-pick] input[data-ufp-cook-size]:checked');
        if (!r) return;
        setTimeout(function () { try { r.focus({ preventScroll: true }); } catch (e) {} }, 0);
      });
    });
  }

  /* ------------------------------------------------------------ "How it works" story
     The row of times above the swipe row is its progress indicator: the time whose card is in view is lit and the
     earlier ones stay marked. A tap on a time slides the row to that card (sideways only). Without this script the
     times are plain links to their cards. */
  function bindStory(root) {
    $$(root, '[data-ufp-cook-story]').forEach(function (sec) {
      if (!once(sec, 'story')) return;
      var car = sec.querySelector('[data-ufp-carousel]');
      var tabs = $$(sec, '[data-ufp-story-go]');
      if (!car || !tabs.length) return;
      var cur = -1;
      function paint(i) {
        if (i === cur || i < 0 || i >= tabs.length) return;
        cur = i;
        tabs.forEach(function (t, n) {
          t.classList.toggle('ufp-lp-is-active', n === i);
          t.classList.toggle('ufp-lp-is-done', n < i);
          if (n === i) t.setAttribute('aria-current', 'step'); else t.removeAttribute('aria-current');
        });
      }
      function api() { var U = window.ufpLp; return U && U.carousel ? U.carousel(car) : null; }
      sec.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('[data-ufp-story-go]') : null;
        if (!a || !sec.contains(a)) return;
        var row = api();
        if (!row) return; // the link stays a plain anchor to its card
        e.preventDefault();
        var i = tabs.indexOf(a);
        paint(i);
        row.go(i, false);
      });
      car.addEventListener('ufp:slide', function (e) { if (e.detail) paint(e.detail.index); });
      // the shared row writes the card in view to data-ufp-carousel-index while it scrolls: follow it at once
      function fromAttr() { var n = parseInt(car.getAttribute('data-ufp-carousel-index'), 10); if (!isNaN(n)) paint(n); }
      if ('MutationObserver' in window) {
        try { new MutationObserver(fromAttr).observe(car, { attributes: true, attributeFilter: ['data-ufp-carousel-index'] }); } catch (e) {}
      }
      fromAttr();
      if (cur < 0) paint(0);
    });
  }

  /* ------------------------------------------------------------ add-on row: arrows, dots and "2 of 5"
     Same look and behaviour as the shared swipe row, but it counts only the cards that are showing, because the
     fit finder hides the ones that do not suit the picked fire pit. The row itself is plain sideways scroll with
     scroll snap; this only adds the controls and never listens for touches. */
  var ICON_PREV = '<svg class="ufp-lp-ico" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg class="ufp-lp-ico" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
  function bindRow(root) {
    $$(root, '[data-ufp-cook-row]').forEach(function (car) {
      if (!once(car, 'row')) return;
      var track = car.querySelector('[data-ufp-cook-track]');
      if (!track) return;
      var all = $$(track, '[data-ufp-cook-slide]');
      if (all.length < 2) return;
      var pattern = car.getAttribute('data-count') || '[n] of [total]';
      var nav = doc.createElement('div');
      nav.className = 'ufp-lp-carousel__nav';
      nav.hidden = true;
      nav.innerHTML = '<button type="button" class="ufp-lp-carousel__arrow" data-ufp-row-prev aria-label="' + esc(car.getAttribute('data-prev') || 'Previous') + '">' + ICON_PREV + '</button>' +
        '<span class="ufp-lp-carousel__dots" aria-hidden="true"></span>' +
        '<span class="ufp-lp-carousel__count ufp-lp-vh" aria-live="polite"></span>' +
        '<button type="button" class="ufp-lp-carousel__arrow" data-ufp-row-next aria-label="' + esc(car.getAttribute('data-next') || 'Next') + '">' + ICON_NEXT + '</button>';
      car.appendChild(nav);
      var prev = nav.querySelector('[data-ufp-row-prev]'), next = nav.querySelector('[data-ufp-row-next]');
      var dotsBox = nav.querySelector('.ufp-lp-carousel__dots'), count = nav.querySelector('.ufp-lp-carousel__count');
      var cur = -1, shown = [], said = false, raf = 0;

      function scrollable() { return track.scrollWidth > track.clientWidth + 4; }
      function maxLeft() { return Math.max(0, track.scrollWidth - track.clientWidth); }
      function leftFor(s) {
        var tr = track.getBoundingClientRect(), sr = s.getBoundingClientRect();
        var pad = parseFloat(window.getComputedStyle(track).scrollPaddingLeft) || 0;
        var x = track.scrollLeft + (sr.left - tr.left);
        x -= /start/.test(window.getComputedStyle(s).scrollSnapAlign || '') ? pad : (tr.width - sr.width) / 2;
        return Math.max(0, Math.min(Math.round(x), maxLeft()));
      }
      function nearest() {
        var best = 0, bestD = Infinity, x = track.scrollLeft;
        shown.forEach(function (s, i) { var d = Math.abs(leftFor(s) - x); if (d < bestD - 0.5) { bestD = d; best = i; } });
        return best;
      }
      function say() {
        if (!shown.length || cur < 0) { count.textContent = ''; return; }
        var label = shown[cur].getAttribute('data-label');
        count.textContent = pattern.replace('[n]', cur + 1).replace('[total]', shown.length) + (label && said ? ': ' + label : '');
      }
      function paint(i) {
        var changed = i !== cur;
        cur = i;
        all.forEach(function (s) { s.classList.toggle('ufp-lp-is-current', s === shown[i]); });
        $$(dotsBox, '.ufp-lp-carousel__dot').forEach(function (d, n) { d.classList.toggle('ufp-lp-is-on', n === i); });
        nav.hidden = shown.length < 2 || !scrollable();
        prev.disabled = i <= 0;
        next.disabled = i >= shown.length - 1 || track.scrollLeft >= maxLeft() - 2;
        car.setAttribute('data-ufp-row-index', String(i));
        car.setAttribute('data-ufp-row-total', String(shown.length));
        if (changed) say();
      }
      function refresh(reset) {
        shown = all.filter(function (s) { return !s.hidden; });
        var dots = '';
        shown.forEach(function () { dots += '<span class="ufp-lp-carousel__dot"></span>'; });
        dotsBox.innerHTML = dots;
        if (reset) { try { track.scrollTo({ left: 0, behavior: 'auto' }); } catch (e) { track.scrollLeft = 0; } }
        cur = -1;
        paint(shown.length ? nearest() : 0);
      }
      function go(i) {
        if (i < 0 || i >= shown.length) return;
        said = true;
        var x = leftFor(shown[i]);
        paint(i);
        say();
        try { track.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = x; }
      }
      prev.addEventListener('click', function () { go(Math.max(0, cur - 1)); });
      next.addEventListener('click', function () { go(Math.min(shown.length - 1, cur + 1)); });
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; if (!shown.length) return; var i = nearest(); if (i !== cur) { said = true; paint(i); } else paint(i); });
      }, { passive: true });
      window.addEventListener('resize', function () { if (shown.length) paint(nearest()); });
      car.ufpCookRefresh = refresh;
      refresh(false);
      car.classList.add('ufp-lp-is-ready');
    });
  }

  /* ------------------------------------------------------------ build: fit chips */
  function parseMap(s) {
    var o = {};
    String(s || '').split(';').forEach(function (pair) {
      if (!pair) return;
      var i = pair.indexOf(':');
      var k = (i < 0 ? pair : pair.slice(0, i)).trim();
      if (k) o[k] = i < 0 ? '' : pair.slice(i + 1).trim();
    });
    return o;
  }
  function syncRow(row) {
    var r = row.querySelector('input[name="id"]:checked');
    var btn = row.querySelector('.ufp-lp-cook-addon__add');
    if (r && btn && r.getAttribute('data-cta')) btn.setAttribute('data-ufp-cta', r.getAttribute('data-cta'));
  }
  function setOption(row, value) {
    var r = value ? row.querySelector('input[name="id"][data-opt="' + String(value).replace(/"/g, '') + '"]') : row.querySelector('input[name="id"][data-default]');
    if (r && !r.checked) r.checked = true;
    syncRow(row);
  }
  function bindBuild(root) {
    $$(root, '[data-ufp-cook-build]').forEach(function (sec) {
      if (!once(sec, 'build')) return;
      var rows = $$(sec, '[data-ufp-addon]');
      var finder = sec.querySelector('[data-ufp-fit]');
      var car = sec.querySelector('[data-ufp-cook-row]');

      rows.forEach(function (row) {
        row.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') syncRow(row); });
        syncRow(row);
      });

      // show the cards the picked fire pit takes, each on the size mapped to it; "All" shows every card on its default
      function apply(key, reset) {
        var all = !key || key === 'all';
        rows.forEach(function (row) {
          if (all) { row.hidden = false; setOption(row, null); return; }
          var map = parseMap(row.getAttribute('data-chips'));
          var hit = Object.prototype.hasOwnProperty.call(map, key) ? key : (Object.prototype.hasOwnProperty.call(map, '*') ? '*' : null);
          row.hidden = hit === null;
          if (hit !== null) setOption(row, map[hit]);
        });
        $$(sec, '[data-ufp-helper]').forEach(function (p) { p.hidden = p.getAttribute('data-ufp-helper') !== (key || 'all'); });
        if (car && car.ufpCookRefresh) car.ufpCookRefresh(reset);
      }
      // keep the picked chip in view inside its own sideways scroller (the page itself never moves)
      function showChip(r) {
        var box = finder && finder.querySelector('.ufp-lp-cook-fit__chips');
        var l = r && r.nextElementSibling;
        if (!box || !l || box.scrollWidth <= box.clientWidth + 2) return;
        var b = box.getBoundingClientRect(), c = l.getBoundingClientRect();
        var x = box.scrollLeft + (c.left - b.left) - (b.width - c.width) / 2;
        x = Math.max(0, Math.min(Math.round(x), box.scrollWidth - box.clientWidth));
        try { box.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { box.scrollLeft = x; }
      }

      var start = 'all';
      if (finder) {
        finder.hidden = false;
        var radios = $$(finder, 'input[data-ufp-fit-key]');
        var q = param('fit');
        var hitRadio = q ? radios.filter(function (r) { return r.value === q; })[0] : null;
        var checked = hitRadio || radios.filter(function (r) { return r.checked; })[0] || radios[0];
        if (checked) { checked.checked = true; start = checked.value; }
        finder.addEventListener('change', function (e) {
          var r = e.target;
          if (!r || !r.hasAttribute || !r.hasAttribute('data-ufp-fit-key')) return;
          apply(r.value, true);
          showChip(r);
          push({ event: 'ufp_fit_select', ufp_fit: r.value, ufp_lander: 'cook' });
        });
        if (hitRadio) setTimeout(function () { showChip(hitRadio); }, 0);
      }
      apply(start, false);
    });
  }

  /* ------------------------------------------------------------ add to cart: theme <product-form> first, own fetch as fallback */
  function drawerOpen() {
    var d = doc.querySelector('#ajax-cart-drawer');
    return !!((d && d.classList.contains('sidebar-visible')) || doc.body.classList.contains('no-scroll'));
  }
  function tagCart(sec) {
    var key = sec && sec.getAttribute('data-ufp-cart-attr');
    if (!key || ss('ufp_cook_cart_attr')) return;
    ss('ufp_cook_cart_attr', '1');
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ attributes: { lander: key } }) }).catch(function () {});
    } catch (e) {}
  }
  function bindAtc(root) {
    $$(root, 'form[data-ufp-cook-atc]').forEach(function (form) {
      if (!once(form, 'atc')) return;
      var sec = form.closest('[data-ufp-cook-build]');
      var btn = form.querySelector('button[type="submit"]');
      var label = btn && btn.querySelector('[data-ufp-btn-label]');
      var err = form.querySelector('[data-form-error]');
      var done = form.querySelector('[data-ufp-atc-done]');
      var copy = sec && sec.querySelector('[data-ufp-err-copy]');
      var html = label ? label.innerHTML : '';
      var adding = (sec && sec.getAttribute('data-adding')) || 'Adding...';
      var added = (sec && sec.getAttribute('data-added')) || 'Added';
      var doneLink = done && done.querySelector('a');
      var doneOk = (sec && sec.getAttribute('data-view-cart')) || (doneLink ? doneLink.textContent : '');
      var doneUnsure = (sec && sec.getAttribute('data-view-cart-unconfirmed')) || doneOk;
      function showDone(sure) {
        if (!done) return;
        if (doneLink) doneLink.textContent = sure ? doneOk : doneUnsure;
        done.hidden = false;
      }
      var timer;
      function reset() {
        if (label) label.innerHTML = html;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      }
      function ok() {
        clearTimeout(timer);
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (label) label.textContent = added;
        showDone(true);
        timer = setTimeout(reset, 2000);
        var r = form.querySelector('input[name="id"]:checked');
        push({ event: 'ufp_add_to_cart', ufp_lander: 'cook', ufp_product: btn && btn.getAttribute('data-ufp-product'), ufp_variant: r && r.value });
        tagCart(sec);
      }
      function fail() {
        clearTimeout(timer);
        reset();
        if (err) {
          if (copy) err.innerHTML = copy.innerHTML; else err.textContent = "That didn't go in. Try again, or call 0410 264 126.";
          err.style.display = 'block';
        }
      }
      form.addEventListener('submit', function (e) {
        var r = form.querySelector('input[name="id"]:checked');
        if (!r || !r.value) { e.preventDefault(); fail(); return; }
        if (err) { err.textContent = ''; err.style.display = 'none'; }
        if (label) label.textContent = adding;
        if (btn) btn.setAttribute('aria-busy', 'true');
        var theme = window.customElements && window.customElements.get('product-form') && form.closest('product-form');
        if (theme) {
          // The theme posts FormData + sections to /cart/add.js and opens its drawer. Watch for 4 s.
          // Disable the button so a double tap (common in the Meta in-app browser) cannot post twice. The theme's
          // own submit listener has already built its FormData by now (theme.js is deferred in <head>), and the
          // button is never part of that FormData. ok(), fail() and the 4 s timeout all re-enable it.
          if (btn) btn.disabled = true;
          var t0 = Date.now();
          var wasOpen = drawerOpen();
          (function watch() {
            if (!wasOpen && drawerOpen()) return ok();
            if (err && err.textContent.trim() && err.style.display !== 'none') return fail();
            // neither the drawer nor an error: the add is not confirmed, so the link says "Check your cart", not "Added"
            if (Date.now() - t0 > 4000) { reset(); showDone(false); return; }
            setTimeout(watch, 150);
          })();
          return;
        }
        if (!window.fetch || !window.FormData) { reset(); return; } // native POST to /cart/add, lands on /cart
        e.preventDefault();
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }, function () { return { ok: res.ok, j: {} }; }); })
          .then(function (x) { if (x.ok && !(x.j && x.j.status)) ok(); else fail(); })
          .catch(fail);
      });
    });
  }

  /* ------------------------------------------------------------ boot */
  function init(root) {
    root = root || doc;
    offerTwins();
    bindRow(root);
    bindBuild(root);
    bindAtc(root);
    bindFocusSize(root);
    bindCompare(root);
    bindStory(root);
    bindPick(root);
  }
  C.init = init;
  // iOS WebKit (the Meta in-app browser on iPhone) shows :active on tap only when a touch listener exists: this empty
  // passive one makes the pills', chips' and buttons' pressed states (the tap equivalent of their hover) appear
  try { doc.addEventListener('touchstart', function () {}, { passive: true }); } catch (e) {}
  doc.addEventListener('click', onLabelClick, true);
  doc.addEventListener('ufp:primary-cta', function (e) { follow(e.detail); });
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
})();
